<template>
  <div
    :class="{
      'card flex h-full flex-col gap-30px pt-12 md:flex-row': true,
      'gap-6 border-b-4 border-b-www-color-primary-lighter bg-www-color-white pb-14 pl-9 pr-7 pt-5 shadow-[0_0_19px_rgba(0,0,0,0.16)] md:flex-col':
        useCardStyle,
    }"
  >
    <div :class="{ 'h-16 w-16 min-w-16 text-left': true }">
      <PtcPicture
        v-if="icon && icon.asset"
        provider="sanity"
        :src="icon.asset._ref"
        :img-attrs="{
          class: { 'block w-[4.8125rem] h-auto': true },
        }"
        :modifiers="{
          crop: icon.crop,
          hotspot: icon.hotspot,
          w: 100,
          h: 100,
        }"
        :quality="75"
        :alt="resolvedImage?.altText || ''"
      />
    </div>
    <div
      :class="{
        'card-content flex h-full flex-col text-www-color-neutral-medium-dark': true,
      }"
    >
      <h5
        :class="{
          'mb-5 text-2xl font-bold leading-7': true,
        }"
      >
        {{ title }}
      </h5>
      <p
        :class="{
          'mb-5 max-w-340px flex-grow text-base font-medium leading-5 md:leading-5': true,
        }"
      >
        {{ description }}
      </p>
      <div
        :class="{
          'flex items-center gap-2': true,
        }"
      >
        <GeneralLink
          v-if="link"
          v-bind="link"
          :class="{
            'mt-auto inline-block font-ptc-Rajdhani text-15px font-bold md:pt-0 md:text-xl': true,
            'text-www-color-primary-light hover:underline': true,
          }"
        />

        <PtcIcon
          v-if="link?.text"
          :class="{
            'h-5 w-25px text-sm font-bold text-www-color-primary-light md:text-xl md:leading-none': true,
          }"
          name="ptc-arrow-white"
        />
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import PtcPicture from '~/components/Atoms/PtcPicture/PtcPicture.vue';
import GeneralLink from '~/components/Molecules/HeaderComponents/GeneralLink.vue';
import PtcIcon from '~/components/Atoms/PtcIcon/PtcIcon.vue';
import type { Callout } from '~/sanity/types';

interface Props extends Callout {
  useCardStyle?: boolean;
}
const props = defineProps<Props>();
const { getResolvedImage } = useRefsStore();
const resolvedImage = await getResolvedImage(props.icon?.asset?._ref);
</script>

<style lang="scss" scoped></style>
